import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Wrapped so tracker.start() only runs in the browser (SSR-safe for Vercel)
function Root() {
  useEffect(() => {
    import("./lib/openreplay").then(({ startTracking }) => startTracking());
  }, []);
  return <App />;
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <Root />
);
